import { Card, Row, Col, Typography, Progress, List, Tag, Space } from "antd"
import {
  EyeOutlined,
} from "@ant-design/icons"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsMore from "highcharts/highcharts-more"
import HighchartsHeatmap from "highcharts/modules/heatmap"

// Initialize Highcharts modules
HighchartsMore(Highcharts)
HighchartsHeatmap(Highcharts)

const { Text, Title } = Typography

const StratigicResource = () => {

  // Strategic Workstream Data
  const workstreamData = [
    {
      objective: "Expand into Canada",
      risksMitigated: 67,
      opportunitiesCaptured: 78,
      completion: 72,
      status: "blocked",
      blocker: "Compliance review",
    },
    {
      objective: "Digital Transformation",
      risksMitigated: 89,
      opportunitiesCaptured: 92,
      completion: 85,
      status: "on-track",
      blocker: null,
    },
    {
      objective: "Supply Chain Optimization",
      risksMitigated: 45,
      opportunitiesCaptured: 34,
      completion: 38,
      status: "at-risk",
      blocker: "Vendor negotiations",
    },
  ]

  const radarChart = {
    chart: { polar: true, type: "line", height: 400 },
    title: { text: "Strategic Workstream Overview" },
    pane: { size: "80%" },
    xAxis: {
      categories: [
        "Risk Mitigation",
        "Opportunity Capture",
        "Task Completion",
        "Resource Allocation",
        "Timeline Adherence",
      ],
      tickmarkPlacement: "on",
      lineWidth: 0,
    },
    yAxis: { gridLineInterpolation: "polygon", lineWidth: 0, min: 0, max: 100 },
    series: [
      {
        name: "Canada Expansion",
        data: [67, 78, 72, 65, 58],
        pointPlacement: "on",
        color: "#1890ff",
      },
      {
        name: "Digital Transformation",
        data: [89, 92, 85, 88, 91],
        pointPlacement: "on",
        color: "#52c41a",
      },
    ],
  }
  return (
      <Card
        title={
          <Space>
            <EyeOutlined style={{ color: "#722ed1" }} />
            <span>Strategic Workstream View</span>
          </Space>
        }
        style={{ marginBottom:  "24px" }}
      >
        <List
          dataSource={workstreamData}
          renderItem={(item) => (
            <List.Item>
              <Card size="small" style={{ width: "100%" }}>
                <Title level={5}>{item.objective}</Title>
                <Row gutter={[8, 8]}>
                  <Col span={12}>
                    <Text>Risks Mitigated:</Text>
                    <Progress percent={item.risksMitigated} size="small" />
                  </Col>
                  <Col span={12}>
                    <Text>Opportunities:</Text>
                    <Progress percent={item.opportunitiesCaptured} size="small" status="active" />
                  </Col>
                  <Col span={24}>
                    <Text>Completion:</Text>
                    <Progress
                      percent={item.completion}
                      size="small"
                      status={item.status === "blocked" ? "exception" : "normal"}
                    />
                  </Col>
                  {item.blocker && (
                    <Col span={24}>
                      <Tag color="red">Blocked: {item.blocker}</Tag>
                    </Col>
                  )}
                </Row>
              </Card>
            </List.Item>
          )}
        />
        <HighchartsReact highcharts={Highcharts} options={radarChart} />
      </Card>
  )
}

export default StratigicResource